import React from 'react';
import { ProductionBucket } from '../../types/bidding';
import { formatCurrency, formatBoardFeet } from '../../utils/bidCalculator';
import './BucketEditor.css';

interface ProductionBucketSummaryProps {
  bucket: ProductionBucket;
  onUpdate?: (bucket: ProductionBucket) => void;
  readOnly?: boolean;
}

const ProductionBucketSummary: React.FC<ProductionBucketSummaryProps> = ({ 
  bucket, 
  onUpdate,
  readOnly = false 
}) => {
  const handleRateChange = (newRate: number) => {
    if (onUpdate) {
      onUpdate({
        ...bucket,
        ratePerBoardFoot: newRate,
        total: bucket.totalBoardFeet * newRate,
      });
    }
  };

  return (
    <div className="bucket-editor production-bucket-summary">
      <div className="bucket-header">
        <h4>Production</h4>
        <div className="bucket-total">{formatCurrency(bucket.total)}</div>
      </div>

      <div className="production-summary">
        <div className="production-row">
          <span className="production-label">Total Board Feet:</span>
          <span className="production-value">{formatBoardFeet(bucket.totalBoardFeet)}</span>
        </div>
        <div className="production-row">
          <span className="production-label">Rate per Board Foot:</span>
          {readOnly || !onUpdate ? (
            <span className="production-value">${bucket.ratePerBoardFoot.toFixed(2)}</span>
          ) : (
            <div className="production-rate-input">
              <span className="rate-prefix">$</span>
              <input
                type="number"
                value={bucket.ratePerBoardFoot}
                onChange={(e) => handleRateChange(parseFloat(e.target.value) || 0)}
                min="0"
                step="0.25"
                className="rate-input"
              />
              <span className="rate-suffix">/BF</span>
            </div>
          )}
        </div>
        <div className="production-row production-total">
          <span className="production-label">Production Labor:</span>
          <span className="production-value">{formatCurrency(bucket.total)}</span>
        </div>
      </div>

      <div className="production-note">
        Board feet calculated from timber list. Adjust rate if needed.
      </div>
    </div>
  );
};

export default ProductionBucketSummary;
